export default __webpack_public_path__ + "static/media/guesty_step1.9572504c.png";